<template>
  <v-container class="py-6">
    <h1 class="text-h6 mb-4">
      Smoke: Pro AI Lucy (production KeywordsList row)
    </h1>
    <KeywordsList
      :keyword-type="keywordType"
      :keywords="keywords"
      :read-only="false"
      :article="article"
      current-selected-keyword="barf pro psy"
      :selected-for-ai="selectedForAi"
      @update:selectedForAi="selectedForAi = $event"
    />
  </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {KeywordType} from '@/enum/keyword_type';
    import KeywordsList from '@/components/keywords/KeywordsList.vue';
    import {Article} from '@/model/Article';
    import {I18n} from '@/plugins/I18n';

    export default Vue.extend({
        name: 'KeywordLucyRowSmokeView',
        components: {KeywordsList},
        created() {
            I18n.locale = 'cs';
        },
        data: () => {
            const article = new Article();
            article.keyword = 'barf pro psy';
            article.selectedKeyword = 'barf pro psy';
            return {
                keywordType: KeywordType.RELATED,
                article,
                selectedForAi: [] as unknown[],
                keywords: [
                    {keyword: 'barf pro psy', keyword_info: {search_volume: 880}},
                    {keyword: 'syrová strava pro psy', keyword_info: {search_volume: 320}},
                    {keyword: 'barf recept', keyword_info: {search_volume: 210}},
                ],
            };
        },
    });
</script>
